/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_Open_ChatInputs */

const cs_client_portal_open_chat = /** @type {(inputs: Client_Portal_Open_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít chat`)
};

const en_client_portal_open_chat = /** @type {(inputs: Client_Portal_Open_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open chat`)
};

/**
* | output |
* | --- |
* | "Open chat" |
*
* @param {Client_Portal_Open_ChatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_open_chat = /** @type {((inputs?: Client_Portal_Open_ChatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_Open_ChatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_open_chat(inputs)
	return cs_client_portal_open_chat(inputs)
});